export default __webpack_public_path__ + "static/media/mdrrmo_seal.12fcc4a4.png";